module.exports = "hr {\n  margin-right: 15px;\n  margin-left: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/tech-support/tech-support.component.scss
// module id = ./src/app/modules/common-main/components/tech-support/tech-support.component.scss
// module chunks = main